export const faqs = [
  {
    id: 1,
    questionEn: 'Do you offer same-day booking?',
    questionAr: 'هل تقدمون حجز في نفس اليوم؟',
    answerEn: 'Yes, we offer same-day booking based on availability. Contact us via WhatsApp or call us to check availability for urgent cleaning services.',
    answerAr: 'نعم، نقدم حجز في نفس اليوم بناءً على التوفر. اتصل بنا عبر واتساب أو اتصل بنا للتحقق من التوفر لخدمات التنظيف العاجلة.'
  },
  {
    id: 2,
    questionEn: 'Are your cleaning products eco-friendly?',
    questionAr: 'هل منتجات التنظيف الخاصة بكم صديقة للبيئة؟',
    answerEn: 'Absolutely! We use eco-friendly and non-toxic cleaning products that are safe for your family, pets, and the environment.',
    answerAr: 'بالتأكيد! نستخدم منتجات تنظيف صديقة للبيئة وغير سامة وآمنة لعائلتك وحيواناتك الأليفة والبيئة.'
  },
  {
    id: 3,
    questionEn: 'Which areas do you cover in Oman?',
    questionAr: 'ما هي المناطق التي تغطونها في عمان؟',
    answerEn: 'We provide cleaning services across all major areas in Oman including Muscat, Seeb, Al Khuwair, Azaiba, Mabela, Sohar, Nizwa, and more.',
    answerAr: 'نقدم خدمات التنظيف في جميع المناطق الرئيسية في عمان بما في ذلك مسقط والسيب والخوير والعذيبة والمعبيلة وصحار ونزوى والمزيد.'
  },
  {
    id: 4,
    questionEn: 'How can I book your services?',
    questionAr: 'كيف يمكنني حجز خدماتكم؟',
    answerEn: 'Booking is easy! Simply click the WhatsApp button on our website, call us directly, or fill out the contact form. We will respond immediately.',
    answerAr: 'الحجز سهل! ببساطة انقر على زر واتساب على موقعنا، أو اتصل بنا مباشرة، أو املأ نموذج الاتصال. سنرد على الفور.'
  },
  {
    id: 5,
    questionEn: 'What are your pricing rates?',
    questionAr: 'ما هي أسعاركم؟',
    answerEn: 'Our pricing is competitive and affordable. Rates vary based on the service type and property size. Contact us for a free quote tailored to your needs.',
    answerAr: 'أسعارنا تنافسية وبأسعار معقولة. تختلف الأسعار بناءً على نوع الخدمة وحجم العقار. اتصل بنا للحصول على عرض أسعار مجاني مصمم خصيصاً لاحتياجاتك.'
  },
  {
    id: 6,
    questionEn: 'Are your staff trained and insured?',
    questionAr: 'هل موظفوكم مدربون ومؤمنون؟',
    answerEn: 'Yes, all our cleaning staff are professionally trained, experienced, and fully insured. Your property is in safe hands with Sea Pearl Universal.',
    answerAr: 'نعم، جميع موظفي التنظيف لدينا مدربون بشكل احترافي وذوي خبرة ومؤمنون بالكامل. ممتلكاتك في أيدٍ آمنة مع سي بيرل يونيفرسال.'
  }
];